"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHubSpotOrigin = isHubSpotOrigin;
exports.getSlug = getSlug;

var _Url = _interopRequireDefault(require("urlinator/Url"));

var URL_WHITELIST = ['https://local.hubspot.com', 'https://local.hubspotqa.com', 'https://app.hubspotqa.com', 'https://app.hubspot.com'];

function isHubSpotOrigin(origin) {
  return URL_WHITELIST.indexOf(origin) > -1;
}

function sanitizePathname(pathname) {
  var lastIndex = pathname.length - 1;

  if (pathname.charAt(lastIndex) === '/') {
    return pathname.substring(0, lastIndex);
  }

  return pathname;
}

function getSlug() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  /**
   * If the pathname contains "/meetings/" (old domain pattern, custom domain pattern)
   * then we should split pathname on 'meetings' to grab the slug
   * Otherwise, we are on the domain pattern meetings.hubspot.com
   * and the slug is just the pathname with leading '/' removed
   * @param {string} href url to parse to get the unique identifier
   * @returns {string} The visible unique identifier of the meeting link
   */
  var url = new _Url.default(href);

  if (url.pathname.indexOf('/meetings/') > -1) {
    return sanitizePathname(url.pathname).split('/meetings/')[1];
  }

  return sanitizePathname(url.pathname).slice(1);
}